export const GET_SOLDE_SUCCESS = "GET_SOLDE_SUCCESS";
export const GET_SOLDE_LOAD = "GET_SOLDE_LOAD";
export const GET_SOLDE_FAILED = "GET_SOLDE_FAILED";
